import { FavoriteSearch } from "search/favoriteSearch";
import { Ref, ref, computed, onMounted } from "vue";
import { searchBalloonStore } from "@host/store/search-balloon";

const SHOW_BALLOON_WAIT_DURATION = 300;
const HIDE_BALLOON_WAIT_DURATION = 100;
const ADJUST_BALLOON_POSITION = 70;
const ADJUST_BALLOON_POSITION_WITH_NO_PERIOD = 30;
const balloonPositionX = "260px";
// whether to display balloon or not
const lastHoveredSearchId: Ref<number | null> = ref(null);
const balloonDisplayTimer: Ref<number | null> = ref(null);
const balloonHideTimer: Ref<number | null> = ref(null);
// where to display balloon
const defaultBalloonTop = ref(0); // Default position of balloon before screen scrolled.
const navScroll = 0;
const homeScroll = 0;

// TODO: refactor
// eslint-disable-next-line max-lines-per-function
export function useFavoriteSearchBalloon() {
  const { balloonPosition, hoveredSearch, isBalloonHover, setPosition, setHoveredSearch, setIsBalloonHover } =
    searchBalloonStore();
  const shouldShowFavoriteSearchBalloon = computed<boolean>(() => balloonPosition.value.positionY !== "");

  function updateBalloonPosition() {
    const balloonPositionY = defaultBalloonTop.value - navScroll + homeScroll + "px";
    setPosition({ positionY: balloonPositionY, arrowAdjust: balloonPosition.value.arrowAdjust });
  }

  function showSearchBalloon(event: MouseEvent, search: FavoriteSearch) {
    if (balloonDisplayTimer.value !== null) clearTimeout(balloonDisplayTimer.value);

    // When hovered favorite search is different with search in Balloon.
    if (search.id !== lastHoveredSearchId.value) {
      resetSearchBalloonStats();
    }

    // Set timer to update balloonPositionY
    balloonDisplayTimer.value = showBalloonTimer(event, search);
  }

  function showBalloonTimer(event: MouseEvent, search: FavoriteSearch) {
    return window.setTimeout(() => {
      setHoveredSearch(search);
      lastHoveredSearchId.value = search.id;
      const evTarget = event.target;
      const target: HTMLDivElement = evTarget as HTMLDivElement;
      if (isFavoriteSearchHasStartDate(search)) {
        setPosition({ positionY: balloonPosition.value.positionY, arrowAdjust: 0 });
        defaultBalloonTop.value = target.getBoundingClientRect().top + navScroll - ADJUST_BALLOON_POSITION;
      } else {
        setPosition({ positionY: balloonPosition.value.positionY, arrowAdjust: -5 });
        defaultBalloonTop.value =
          target.getBoundingClientRect().top + navScroll - ADJUST_BALLOON_POSITION_WITH_NO_PERIOD;
      }
      updateBalloonPosition();
    }, SHOW_BALLOON_WAIT_DURATION);
  }

  function hideSearchBalloon() {
    if (balloonDisplayTimer.value !== null) {
      clearTimeout(balloonDisplayTimer.value);
    }

    // Set timer to update balloonPositionY
    balloonHideTimer.value = window.setTimeout(() => {
      if (!isBalloonHover.value) {
        resetSearchBalloonStats();
      }
      //  delete timer after use
      if (balloonHideTimer.value !== null) {
        clearTimeout(balloonHideTimer.value);
        balloonHideTimer.value = null;
      }
    }, HIDE_BALLOON_WAIT_DURATION);
  }

  function resetSearchBalloonStats() {
    setPosition({ positionY: "", arrowAdjust: 0 });
  }

  const style = () => ({ left: balloonPositionX, top: balloonPosition.value.positionY });
  function onMouseEnterSavedSearchBalloon() {
    setIsBalloonHover(true);
    // TODO: stopWindowScrollWithScrollbarDisplay();
    if (balloonDisplayTimer.value !== null) {
      clearTimeout(balloonDisplayTimer.value);
    }
  }
  function onMouseLeaveSavedSearchBalloon() {
    setIsBalloonHover(false);
    // hide balloon when move out of cell
    balloonDisplayTimer.value = window.setTimeout(() => {
      if (!isBalloonHover.value) {
        resetSearchBalloonStats();
      }
    }, HIDE_BALLOON_WAIT_DURATION);
  }

  onMounted(() => {
    resetSearchBalloonStats();
  });

  return {
    shouldShowFavoriteSearchBalloon,
    hoveredSearch,
    balloonPosition,
    style,
    showSearchBalloon,
    hideSearchBalloon,
    resetSearchBalloonStats,
    onMouseEnterSavedSearchBalloon,
    onMouseLeaveSavedSearchBalloon,
  };
}

function isFavoriteSearchHasStartDate(search: FavoriteSearch) {
  return search.searchHistory.selectCondition && "startDate" in search.searchHistory.selectCondition;
}
